import React from 'react';

// import { Container } from './styles';

const Style: React.FC = () => {
  return <div>Style</div>;
};

export default Style;
